__turbopack_context__.v({
  "bookBtn": "CouponDetail-module__O50RPG__bookBtn",
  "codeBox": "CouponDetail-module__O50RPG__codeBox",
  "codeText": "CouponDetail-module__O50RPG__codeText",
  "contentWrap": "CouponDetail-module__O50RPG__contentWrap",
  "copyBtn": "CouponDetail-module__O50RPG__copyBtn",
  "ctaCard": "CouponDetail-module__O50RPG__ctaCard",
  "ctaDesc": "CouponDetail-module__O50RPG__ctaDesc",
  "ctaTitle": "CouponDetail-module__O50RPG__ctaTitle",
  "detailsTable": "CouponDetail-module__O50RPG__detailsTable",
  "emptyState": "CouponDetail-module__O50RPG__emptyState",
  "iconBtn": "CouponDetail-module__O50RPG__iconBtn",
  "layout": "CouponDetail-module__O50RPG__layout",
  "loadingWrap": "CouponDetail-module__O50RPG__loadingWrap",
  "mainCol": "CouponDetail-module__O50RPG__mainCol",
  "mobileCta": "CouponDetail-module__O50RPG__mobileCta",
  "mobileDetailBlock": "CouponDetail-module__O50RPG__mobileDetailBlock",
  "mobileDetails": "CouponDetail-module__O50RPG__mobileDetails",
  "offerCard": "CouponDetail-module__O50RPG__offerCard",
  "offerCardHeader": "CouponDetail-module__O50RPG__offerCardHeader",
  "offerCardTitle": "CouponDetail-module__O50RPG__offerCardTitle",
  "overviewLabel": "CouponDetail-module__O50RPG__overviewLabel",
  "page": "CouponDetail-module__O50RPG__page",
  "sidebarCol": "CouponDetail-module__O50RPG__sidebarCol",
  "tableCell": "CouponDetail-module__O50RPG__tableCell",
  "tableLabel": "CouponDetail-module__O50RPG__tableLabel",
  "tableLabelDiv": "CouponDetail-module__O50RPG__tableLabelDiv",
  "tableValue": "CouponDetail-module__O50RPG__tableValue",
});
